// extracted by mini-css-extract-plugin
export default {"container":"_6ovT94iLbgiUsP8L80thDD","name":"_7g5KwOEDHaI80rWmOFWhH3","reviewsContainer":"_5Lm4ZmVM3D0PrODjjT30aA","reviewsStarsContainer":"_6C1PQMIOHgkRdOHkrUTY3I"};